<template>
	<div class="container">
		<ul class="breadcrumb nav-tabs nav-flex">
		    <li class="active">
				<span id="add-product" class="breadcrumb-container" @click="tabClicked" data-id="0" data-toggle="tab" href="#shopping-cart-add">
				  	<span class="breadcrumb-number">1</span>
				  	<span class="breadcrumb-title hidden-xs">Añadir productos al carrito</span>
				</span>
		    </li>
			<li>
		  		<span id="address" class="breadcrumb-container" @click="tabClicked" data-id="1" data-toggle="tab" href="#shopping-cart-address">
					<span class="breadcrumb-number">2</span>
					<span class="breadcrumb-title hidden-xs">Dirección</span>
				</span>
		  	</li>
			<!-- <li>
				<span id="shipping" class="breadcrumb-container" @click="tabClicked" data-id="2" data-toggle="tab" href="#shopping-cart-shipping">
					<span class="breadcrumb-number">3</span>
					<span class="breadcrumb-title hidden-xs">Método de envío</span>
				</span>
			</li> -->
			<li>
				<span id="payment" class="breadcrumb-container" @click="tabClicked" data-id="2" data-toggle="tab" href="#shopping-cart-payment">
					<span class="breadcrumb-number">3</span>
					<span class="breadcrumb-title hidden-xs">Método de pago</span>
				</span>
			</li>
			<li>
				<span id="summary" class="breadcrumb-container" @click="tabClicked" data-id="3" data-toggle="tab" href="#shopping-cart-summary">
					<span class="breadcrumb-number">4</span>
					<span class="breadcrumb-title hidden-xs">Resumen</span>
				</span>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	vuex: {
		getters: {
			allow_continue: state => state.allow_continue
		}
	},

	// computed: {
	// 	render_user () {
	// 		return this.user
	// 	}
	// },

	methods: {
		tabClicked (e) {
			let vm = this;
			let target = e.target;

			if (!e.target.classList.contains('breadcrumb-container'))
				target = target.parentNode;

			if (!vm.allow_continue[target.dataset.id]) {
				e.stopPropagation();
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// Breadcrumb.vue?06325265